import { Card } from "@mui/material";
import { styled } from "@mui/material/styles";

const StatCard = styled(Card)({
  padding: "20px",
  backgroundColor: "farm.contrastText",
  borderRadius: 12,
  textAlign: "left",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
});

const FieldCard = styled(Card)({
  display: "flex",
  alignItems: "center",
  marginBottom: 12,
});

const buttonStyles = {
  backgroundColor: "farm.main",
  color: "farm.contrastText",
  borderRadius: "8px",
  padding: "8px 10px",
  fontWeight: "bold",
  display: "flex",
  alignItems: "center",
  gap: 1,
  "&:hover": { backgroundColor: "#3D5C3D" },
};

const badgeStyle = {
  backgroundColor: "farm.contrastText",
  color: "farm.main",
  borderRadius: "50%",
  width: 24,
  height: 24,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "14px",
  fontWeight: "bold",
};

const FarmerDetailsStyles = {
  StatCard,
  FieldCard,
  buttonStyles,
  badgeStyle,
};

export default FarmerDetailsStyles;
